import React, { useState } from 'react';
import DownloadReport from '../../../../../components/ui/DownloadReport/DownloadReport';
import AvailableDocumentationModal from '../../../../../../../components/AvailableDocumentationModal/AvailableDocumentationModal';
import useChangeModalVisible from '../../../../../../../hooks/useChangeModalVisible';
import request from '../../../../../../../helpers/request';
import { getBlobUrl } from '../../../../../../../helpers/getBlobUrl';
import { useParams } from 'react-router-dom';

const FlatDownloadReports = ({ awailableReports }) => {
  const [reports, setReports] = useState([]);

  const params = useParams();

  const { visible, showModal, hideModal } = useChangeModalVisible();

  const handleChange = (value) => {
    setReports(value);
  };

  const handleCancel = () => {
    setReports([]);
    hideModal();
  };

  const handleOk = async () => {
    reports.forEach(async (item) => {
      const report = awailableReports?.find(
        (awailableReport) => awailableReport.id === item
      );

      if (report) {
        const res = await request.get(
          report.url,
          { addressId: params.pageTabId },
          `При загрузке отчета "${report.name}" произошла ошибка`
        );

        if (res?.length) {
          res.forEach(({ data, fileName }) => {
            const url = getBlobUrl(data);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          });
        }
      }
    });

    handleCancel();
  };

  return (
    <>
      <DownloadReport onClick={showModal} />
      <AvailableDocumentationModal
        visible={visible}
        okBtnText="Получить отчеты"
        modalTitle="Отчеты"
        onCancel={handleCancel}
        onOk={handleOk}
        selectTitle="Выберите отчеты"
        selectPlaceholder="Выберите один или несколько отчетов из списка"
        selectedItems={reports}
        onSelectChange={handleChange}
        items={awailableReports}
      />
    </>
  );
};

export default FlatDownloadReports;
